import React from "react";
import { Helmet } from "react-helmet-async";

export default function RoyalFortune() {
  const titlePage = 'Royal Fortune | Weblax';
  const description = 'Application mobile de divertissement casino-like.';

  return (
    <>
      <Helmet>
        <title>{titlePage}</title>
        <meta name="description" content={description} />
      </Helmet>

      <main className="weblax-container py-20">
        <h1 className="weblax-heading-display mb-6">Royal Fortune</h1>
        <p className="text-lg text-muted-foreground mb-10">Application mobile de divertissement casino-like.</p>


        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Contexte</h2>
          <p className="text-muted-foreground">Expérience immersive.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Solution</h2>
          <p className="text-muted-foreground">Jeux interactifs mobile.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Résultats</h2>
          <p className="text-muted-foreground">Engagement utilisateur.</p>
        </section>
        
      </main>
    </>
  );
}
